import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import '../styles/Pages.css';

function LinkagePage() {
    const linkages = [
        { name: 'Savitribai Phule Pune University (SPPU)', type: 'University Affiliation', desc: 'Academic affiliation for curriculum, examinations, and degrees.' },
        { name: 'NAAC (National Assessment and Accreditation Council)', type: 'Accreditation', desc: 'College accredited with NAAC "B" Grade, ensuring quality benchmarks.' },
        { name: 'UGC (University Grants Commission)', type: 'Funding & Regulation', desc: 'Grants for college development, research, and faculty advancement.' },
        { name: 'INFLIBNET N-LIST', type: 'Digital Resources', desc: 'Access to national e-library resources for students and faculty.' },
        { name: 'Maharashtra State Government', type: 'State Regulatory Body', desc: 'Compliance with state higher education directives and scholarship schemes.' },
    ];
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Linkage</p>
                <h1>Linkage</h1>
                <p>Our academic, research, and institutional linkages with external bodies.</p>
            </div>
            <div className="page-content">
                <div className="cards-grid">
                    {linkages.map(l => (
                        <div className="grid-card" key={l.name}>
                            <h3>{l.name}</h3>
                            <p style={{ fontWeight: 600, color: '#2d6a4f', fontSize: '0.82rem', marginBottom: '0.3rem' }}>{l.type}</p>
                            <p>{l.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default LinkagePage;
